import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateStep,
} from '../../../Redux/Slice/stepSlice';

const StructureBanner = () => {

  const dispatch = useDispatch()
  const steps = useSelector((state) => state.step.value)

  // const handleUpdateStep = () => {
  //   dispatch(updateStep(steps))
  // }

  return (
    <div>
      <div className="container-fluild overflow-hidden">
        <section className="nebopan">
          <div
            className="nebopan-banner-section"
            style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/images/maxresdefault-5.png")'}}
          >
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <p className=" centered-p">Devis de Terrasse extérieure</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="page-banner">
        <div className="container">
          <div className="d-flex">
            <div className="m-auto">
              {/* <h3 class="page-title">BOIS DE CONSTRUCTION</h3> */}
              <div className="breadcrumbss">
                <Link to='/'>
                  <div className="breadcrumb-item passed">Essence</div>
                </Link>
                <Link to='/stucture'>
                  <div className="breadcrumb-item active">Structure</div>
                </Link>
                <Link to='/accessories'>
                  <div className="breadcrumb-item " >Accessoires</div>
                </Link>
                <Link to='/finalization'>
                  <div className="breadcrumb-item">Finalisation</div>
                </Link>
              </div>
              <h2 className="title">Structure de votre terrasse</h2>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default StructureBanner